var zhHans = {
  "footer.copyright": "Ubiquiti Inc. 版权所有。",
  "footer.header.buy": "立即购买",
  "footer.header.company": "公司简介",
  "footer.header.social": "社交",
  "footer.header.terms": "条款",
  "footer.header.tools": "工具",
  "footer.header.training": "认证培训",
  "footer.link.becomeTrainer": "成为培训师",
  "footer.link.blog": "博客",
  "footer.link.calendar": "培训日历",
  "footer.link.careers": "工作机会",
  "footer.link.caseStudies": "案例研究",
  "footer.link.compliance": "合规",
  "footer.link.contact": "联系我们",
  "footer.link.courses": "培训课程",
  "footer.link.designCenter": "UniFi 设计中心",
  "footer.link.distributor.become": "成为分销商",
  "footer.link.distributor.find": "寻找分销商",
  "footer.link.downloads": "下载",
  "footer.link.investors": "投资者",
  "footer.link.legal": "法律条款",
  "footer.link.store": "Ubiquiti 官方商城",
  "footer.link.terms.conditions": "条款及条件",
  "footer.link.terms.cookie": "Cookies 设置",
  "footer.link.terms.faq": "常见问题",
  "footer.link.terms.policy.privacy": "私隐政策",
  "footer.link.terms.policy.return": "退货政策",
  "footer.link.terms.service": "服务条款",
  "footer.link.trainers": "培训师",
  "footer.link.trustCenter": "信任中心",
  "footer.link.uisp": "UISP",
  "footer.link.uispDesignCenter": "UISP 设计中心",
  "footer.link.wifiman": "WiFiman",
  "footer.newsletter.email": "邮箱",
  "footer.newsletter.error": "发生错误，请稍后再试。",
  "footer.newsletter.error.invalidEmail": "请输入有效的电子邮件地址。",
  "footer.newsletter.error.missingEmail": "请输入有效的电子邮件地址。",
  "footer.newsletter.error.tooManyRequests": "请求过多，请稍后再试。",
  "footer.newsletter.subscribe": "订阅",
  "footer.newsletter.success": "感谢您的订阅！",
  "footer.newsletter.touch": "邮件订阅",
  "footer.support": "技术支持",
  "footer.whats-new": "新品介绍"
};
export { zhHans as default };
//# sourceMappingURL=zh-Hans.json.mjs.map
